import type { SnippetBodyFormat, SnippetProduct, SnippetStatus } from '../snippetTypes.ts';

export class SnippetError extends Error {
	constructor(message: string) {
		super(`Snippet error: ${message}`);
	}
}

export type SnippetData = {
	resourceId: string; // ARI of the Snippet
	snippetId: string;
	name: string; // User defined name
	description?: string; // User defined name
	body: string; // String of the type defined in `bodyFormat` (example: "ADF")
	bodyFormat: SnippetBodyFormat;
	product: SnippetProduct;
	label?: string;
	isFavorite: 0 | 1;
	status: SnippetStatus;
	createdBy: string;
	createdAt: string; // String of integer timestamp
	updatedAt: string; // String of integer timestamp
};

/** Payload for creating or updating a snippet */
export type CreateSnippetPayload = {
	name: string;
	body: string;
	bodyFormat: SnippetBodyFormat;
	product: SnippetProduct;
	description?: string;
};

export type UpdateSnippetPayload = {
	name: string;
	body: string;
	description?: string;
};

export type FetchSnippetScope = 'user' | 'global';
